import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { InventorySubMenu } from '../../../../utils/enums';
import { InteractiveDataTable } from '../../../shared/interactive-data-table/interactive-data-table';
import { EmptyState } from '../../../shared/empty-state/empty-state';
import { IconType } from '../../../shared/custom-icon/custom-icon';
import { addressesGroupsFiltersConfig } from '../../../shared/filters/filter-config/address-groups-filters';
import { useAddressGroupsColumns } from './address-groups-columns-config';
import { useAddressGroupsCrudConfig } from './address-groups-crud-config';
import { getIpFiltersDisplay } from '../../../../utils/filters-util';

export const AddressGroups: React.FC = observer(() => {
    const {fwVersionStore, customerStore} = useStores();
    const { getAddressGroups, selectedFwVersion, isLoading} = fwVersionStore;
    const config = useAddressGroupsCrudConfig();
    const addressGroupsColumns = useAddressGroupsColumns();

    useEffect(() => {
        fwVersionStore.setInventoryType(InventorySubMenu.GROUPS);
    }, []);

    const filterConfig = useMemo(() => {
        const filters = addressesGroupsFiltersConfig(fwVersionStore.getAddresses, fwVersionStore.selectedVersionRules);
        if(!customerStore.selectedLocation) return filters;
        return getIpFiltersDisplay(customerStore.selectedLocation.ipv6Supported, filters, true);
    }, [fwVersionStore.selectedFwVersion, customerStore.selectedLocation?.ipv6Supported, fwVersionStore.getAddresses, fwVersionStore.selectedVersionRules]);

    return <div className="address-groups" data-testid="address-groups">
        <InteractiveDataTable
            filterConfig={filterConfig}
            data={getAddressGroups}
            columnsConfig={addressGroupsColumns}
            crudConfig={config}
            emptyStateComp={<EmptyState
                iconType={IconType.AllowEmptyState}
                subTitle="To add new item click"
                secondarySubTitle=" Add Address Group"
            />}
            dataHasLoaded={!!selectedFwVersion}
            isLoading={isLoading}
        />
    </div>;
});